import moment from 'moment/moment';

import { DISPLAY_DATE_FORMAT } from './constants';

export function formatValueHistoryDate(value) {
  if (!value) {
    return '';
  }
  const parsed = moment(value, moment.ISO_8601);
  return parsed.isValid() ? parsed.format(DISPLAY_DATE_FORMAT) : '';
}
